var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEigenheimIconsPresent(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 57,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.25 55.24H8.1a2.58 2.58 0 01-2.57-2.58V25.29h47.29v27.37a2.58 2.58 0 01-2.57 2.58z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53 26.29v26.37a1.58 1.58 0 001.57 1.58h42.15a1.57 1.57 0 001.57-1.58V26.29H6.53zm43.72 30H8.1a3.58 3.58 0 01-3.57-3.58V25.29a1 1 0 011-1h47.29a1 1 0 011 1v27.37a3.58 3.58 0 01-3.57 3.58v.05z",
    fill: "#546FBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.61 13.77H2.74A1.74 1.74 0 001 15.51v9.78h56.35v-9.78a1.74 1.74 0 00-1.74-1.74z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 24.29h54.35v-8.78a.74.74 0 00-.74-.74H2.74a.74.74 0 00-.74.74v8.78zm55.35 2H1a1 1 0 01-1-1v-9.78a2.74 2.74 0 012.74-2.74h52.87a2.74 2.74 0 012.74 2.74v9.78a1 1 0 01-1 1z",
    fill: "#546FBB"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2CFE0",
    d: "M33.12 55.23h-7.89V13.77h7.89v41.46z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#546FBB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.23 54.24h5.89V14.77h-5.89v39.47zm6.89 2h-7.89a1 1 0 01-1-1V13.77a1 1 0 011-1h7.89a1 1 0 011 1v41.47a1 1 0 01-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.16 3a6.5 6.5 0 00-1.06.09c-2.84.45-4.56 1.58-5.1 3.35a5 5 0 00.64 4c1.76 1.45 8.31 1.77 12.72 1.65C26.8 9.11 25.5 5.67 23.3 4a5.07 5.07 0 00-3.14-1zm5.29 11.14c-3.8 0-9.86-.3-12.08-2.12-1-.81-2-3.54-1.33-6 .49-1.82 2.07-4.16 6.74-4.91a7.29 7.29 0 015.71 1.32c3.72 2.76 4.78 8.7 5 10.45a1 1 0 01-.22.8 1 1 0 01-.71.39c-.36 0-1.55.07-3.13.07h.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 12.12c4.41.12 11-.2 12.73-1.65a5 5 0 00.63-4c-.54-1.77-2.25-2.9-5.1-3.35a5.28 5.28 0 00-4.2 1c-2.19 1.63-3.5 5.07-4.06 8.08v-.08zm1.91 2c-1.58 0-2.77-.05-3.13-.07a1 1 0 01-.94-1.15c.25-1.79 1.32-7.73 5-10.49a7.31 7.31 0 015.73-1.3c4.67.75 6.25 3.09 6.74 4.89C47 8.48 46 11.21 45 12c-2.23 1.82-8.29 2.12-12.09 2.12z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEigenheimIconsPresent);
export default __webpack_public_path__ + "static/media/eigenheim_icons_present.2bbc3a47769e642ba3fa4974ffe331c5.svg";
export { ForwardRef as ReactComponent };